module.exports = __webpack_public_path__ + "images/certificate-open-graph.png";